import { Member } from '../../../models/domain/member';
import { Subscription } from 'rxjs';
import { MemberEventsService } from '../../../services/member.events.service';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { MemberManager } from '../../../managers/member.manager';
import { Note, NoteArray, NoteTypes } from '../../../models/domain/note';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NoteManager } from '../../../managers/note.manager';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { License } from '../../../models/domain/license';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { DialogService } from '../../../services/modal-dialogs';
import { NoteDetailsDialog } from '../../../dialogs/note.details/note.details.dialog';


@Component({
    selector: 'sticky-note',
    templateUrl: './member.sticky.note.component.html',
    styleUrls: ['./member.sticky.note.component.css']
})
export class MemberStickyNoteComponent implements OnInit, OnDestroy {

    @Input('Notes') Notes: NoteArray = new NoteArray();
    private subscriptions = new Array<Subscription>();

    // to prevent double inserts
    private lastNoteAddIndex = -1;

    
    constructor(private memberEvents: MemberEventsService, private windowService: WindowService, private dialogService: DialogService ) {
    }

    ngOnInit() {
        this.SubscribeEvents();
    }

    ngOnDestroy() {
        this.UnsubscribeEvents();
    }

    UnsubscribeEvents() {
        if (this.subscriptions != null)
            this.subscriptions.forEach((s) => { s.unsubscribe() })
    }

    SubscribeEvents() {
        // memberevents
        let memberEvents = this.memberEvents.onNoteChanged.subscribe((args: EntityChangedArgs<any>) => {
            this.CheckNoteOnChanged(args);
            return true;
        })
        this.subscriptions.push(memberEvents);
    }

    NormalizeNoteRelation(note: Note): Note {

        if (note.RelationObject != null) {
            switch (Note.GetNoteType(note)) {

                case NoteTypes.Member:
                    note.RelationInfo = (<Member>note.RelationObject).FirstName + ' ' + (<Member>note.RelationObject).LastName;
                    break;

                case NoteTypes.LicenseKey:
                    note.RelationInfo = (<License>note.RelationObject).Key;
                    break;

                default:
                    note.RelationInfo = '';
            }
        }

        return note;
    }

    CheckNoteOnChanged(args: EntityChangedArgs<Note>) {

        // normalize data
        args.New = this.NormalizeNoteRelation(args.New);

        // add
        if (this.Notes == null && args.New.Sticky) {
            this.Notes.push(args.New);
            return;
        }

        // find in list if exist;
        let index = this.Notes.findIndex(x => x.ID == args.Original.ID);

        if (args.New.Sticky == true && index == -1) {
            // we have a new sticky note
            this.AddNoteToList(args.New);
        } else if (args.New.Sticky == false && index > -1) {
            // we removed one sticky note
            this.Notes.splice(index, 1);
        } else {
            // we maybe changed the note content;
            this.RewriteNote(args.New);
        }

    }

    GetNoteTypeString(note: Note): string {
        // for the html
        return Note.GetNoteTypeString(note);
    }

    RewriteNote(note: Note) {
        let index = this.Notes.findIndex(x => x.ID == note.ID);
        if (index > 0) {
            let xNote = this.Notes[index];
            xNote.Note = note.Note;
            xNote.AdminID = note.AdminID;
            xNote.AdminName = note.AdminName;
            xNote.Modified = note.Modified;
        }
    }

    AddNoteToList(note: Note) {
        let index = this.Notes.findIndex(x => x.ID == note.ID);
        if (index < 0 && note.ID != this.lastNoteAddIndex) {
            this.lastNoteAddIndex = note.ID;
            this.Notes.push(note);
        }
    }


    EditStickyNote(note: Note) {
        // let noteManager = new NoteManager(new NoteManagerConstructor(note.ID));
       // this.ShowNoteWindow(new NoteManagerConstructor(note.ID));
        let noteData = new NoteManagerConstructor(note.ID);
        this.ShowNoteDialog(noteData);
    }



    ShowNoteDialog(noteData: NoteManagerConstructor) {
        let note = new NoteManager(noteData);
        let options = {
            width: 1240,
            height: 650
        }
        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: note }, options).subscribe(response => {
            disposable.unsubscribe();
        })
    }

    EditStickyNoteNotStick(note: Note) {
        let noteData = new NoteManagerConstructor(note.ID);
        noteData.ShowAfterLoad = false;
        let noteManager = new NoteManager(noteData);

        let loaded = noteManager.OnDataLoaded.subscribe((note) => {
            noteManager.newEntity.Sticky = false;
            noteManager.SaveChanges(false, true);
            loaded.unsubscribe();
        });

    }



    onRelationClick(note: Note) {
        switch (Note.GetNoteType(note)) {
            case NoteTypes.Member:
                let memberManager = new MemberManager(note.NoteTypeList[0].Value);
                break;

            case NoteTypes.LicenseKey:
                let licenseID = Note.GetNoteTypeValue(note.NoteTypeList, NoteTypes.LicenseKey);
                this.ShowLicenseWindow(licenseID); // let licenseManager = new LicenseManager(licenseID.toString());
                break;

            case NoteTypes.GISCredit:
                return;
        }
    }

    ShowLicenseWindow(licenseID: number) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<string>(WindowTypes.License, licenseID.toString(), windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                subscription.unsubscribe();
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }


    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {

            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }


}
